module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_rogaland_neg.b1397e7e.png";